import Vue from "vue";
import MapProject from "./MapProject.vue";
import vuelidate from "vuelidate";
import * as VueGoogleMaps from "vue2-google-maps";
import {prepareConfigs, prepareRequestApi} from "@/utils/request";
import axios from "axios";

Vue.use(vuelidate);

(async function() {
  if( !document.querySelector("#zipcode-map-project") ){
    return
  }
  const request = prepareRequestApi();
  const keyData = await axios(request);

  if (keyData.status !== 200) {
    alert("Config Google API Key Error");
  }
  const key: string = keyData.data;

  Vue.use(VueGoogleMaps, {
    load: {
      language: "En",
      key: key,
      libraries: "places" // This is required if you use the Autocomplete plugin
    },
    autobindAllEvents: false,
  });
  Vue.config.productionTip = false;

  const requestConfig = prepareConfigs();
  const resultData = await axios(requestConfig);
  if (resultData.status == 200) {
    Vue.prototype.$globalConfig = resultData.data
  }

  new Vue({
    render: h => h(MapProject)
  }).$mount("#zipcode-map-project");
})();
